var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7289 35.4613V34.4736C27.3087 34.2697 26.9014 34.0365 26.5101 33.775C24.8243 32.6486 23.5103 31.0475 22.7344 29.1743C21.9585 27.3012 21.7555 25.24 22.1511 23.2514C22.5466 21.2628 23.523 19.4362 24.9566 18.0025C26.3903 16.5689 28.2169 15.5925 30.2055 15.197C32.194 14.8014 34.2552 15.0044 36.1284 15.7803C38.0016 16.5562 39.6026 17.8702 40.7291 19.556C41.8555 21.2418 42.4567 23.2238 42.4567 25.2513C42.4538 27.9692 41.3728 30.575 39.4509 32.4968C38.6408 33.307 37.7091 33.9677 36.6988 34.4612V35.4612C39.2412 36.1532 41.6096 37.4298 43.6035 39.2145C46.735 42.0174 48.723 44.8503 49.1871 49.0273C49.213 49.2659 49.1885 49.5072 49.115 49.7357C49.0415 49.9642 48.9206 50.1746 48.7604 50.3532C48.6002 50.5319 48.4041 50.6748 48.1849 50.7726C47.9658 50.8704 47.7285 50.921 47.4885 50.921L32.2141 54.0001L16.9398 50.921C16.6998 50.921 16.4625 50.8704 16.2434 50.7726C16.0242 50.6748 15.8281 50.5319 15.6679 50.3532C15.5077 50.1746 15.3868 49.9642 15.3133 49.7357C15.2398 49.5072 15.2153 49.2659 15.2412 49.0273C15.7053 44.8503 17.6933 42.0174 20.8248 39.2145C22.8185 37.4299 25.1866 36.1534 27.7289 35.4613Z",
    fill: "#D7BDFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 23,
    stroke: "#AF7BFF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4435 16.4431L47.5562 47.5558",
    stroke: "#AF7BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccounts);
export default __webpack_public_path__ + "static/media/NoAccounts.491a89f00a0112283d4c260aa23f43ef.svg";
export { ForwardRef as ReactComponent };